import { registerComponent } from '@gig/magic-common';
import BonusesTransactionsComponent from './bonuses.vue.js';

var BonusesTransactions = registerComponent(BonusesTransactionsComponent);

export { BonusesTransactions };
